import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from "@sentry/react";
import './index.css'
import App from './App.jsx'

// Initialize Sentry before the app renders
Sentry.init({
    dsn: "https://acf76724b169b00c4ca1cdeefb404ab8@o4511929911148544.ingest.us.sentry.io/4511929917636608",
    dataCollection: {
        // To disable sending user data and HTTP bodies, uncomment the lines below. For more info visit:
        // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#dataCollection
        // userInfo: false,
        // httpBodies: []
    }
});

// We keep your existing 'root' element and StrictMode setup here
createRoot(document.getElementById('root')).render(
    <StrictMode>
        <App />
    </StrictMode>,
)